var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 5.625C6.56437 5.625 6.75 5.77389 6.75 5.96289C6.74988 6.05046 6.70801 6.12489 6.64062 6.18555L3.6875 8.88477C3.61156 8.95227 3.50156 9 3.375 9C3.24844 9 3.13844 8.95227 3.0625 8.88477L0.109375 6.18555C0.0419898 6.12489 0.000124988 6.05046 0 5.96289C0 5.77389 0.185625 5.625 0.421875 5.625H6.32812ZM3.375 0C3.50156 6.23716e-08 3.61156 0.0477344 3.6875 0.115234L6.64062 2.81445C6.70801 2.87511 6.74988 2.94954 6.75 3.03711C6.75 3.22611 6.56437 3.375 6.32812 3.375H0.421875C0.185625 3.375 1.65229e-08 3.22611 0 3.03711C0.00012517 2.94954 0.0419898 2.87511 0.109375 2.81445L3.0625 0.115234C3.13844 0.0477344 3.24844 1.10644e-08 3.375 0Z",
    fill: "#484964"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerPage);
export default __webpack_public_path__ + "static/media/PerPage.660bb0c6403b435071fabef7187eb068.svg";
export { ForwardRef as ReactComponent };